const DEFAULT_LOCAL_API = 'http://localhost:3001/api';
const DEFAULT_REMOTE_API = 'https://calmnote-zio3.onrender.com/api';
const DEFAULT_API_PATH = '/api';

const normalizeBase = (url) => (url ? url.replace(/\/$/, '') : url);
const normalizePath = (path) => {
  if (!path) return '';
  return path.startsWith('/') ? path : `/${path}`;
};

const resolveFallbackBase = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocalhost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '0.0.0.0';
    return isLocalhost ? DEFAULT_LOCAL_API : DEFAULT_REMOTE_API;
  }

  return process.env.NODE_ENV === 'production'
    ? DEFAULT_REMOTE_API
    : DEFAULT_LOCAL_API;
};

const ensureApiPrefix = (base, path) => {
  if (!base) return base;
  const normalizedBase = normalizeBase(base);
  const apiPath = normalizePath(path ?? DEFAULT_API_PATH);

  if (!apiPath) return normalizedBase;

  const hasApiAlready =
    normalizedBase.endsWith(apiPath) ||
    normalizedBase.includes(`${apiPath}/`);

  return hasApiAlready ? normalizedBase : `${normalizedBase}${apiPath}`;
};

const API_PATH =
  process.env.REACT_APP_API_PATH === undefined
    ? DEFAULT_API_PATH
    : process.env.REACT_APP_API_PATH;

const rawBase =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API_URL ||
  resolveFallbackBase();

const API_BASE = ensureApiPrefix(rawBase, API_PATH);

export const getApiBase = () => API_BASE;

export async function apiFetch(path, init = {}) {
  const normalizedPath =
    typeof path === 'string' && !path.startsWith('http')
      ? path.startsWith('/')
        ? path
        : `/${path}`
      : path;
  const url =
    typeof normalizedPath === 'string' && normalizedPath.startsWith('http')
      ? normalizedPath
      : `${API_BASE}${normalizedPath || ''}`;
  return fetch(url, init);
}

export default { apiFetch, getApiBase };
